export class CustomCookies {

    // GA_ID = null;

    _dom = {
        script: null,
    };

    constructor() {
        // console.log("GoogleAnalytics class")
        // this.GA_ID = document
        //     .querySelector("meta[name='google-tag-manager']")
        //     .getAttribute("content");
        //
        // if (!this.GA_ID) return;

        this.initListerner();
    }

    initializeEmbeds() {
        // Find all video containers
        const videoContainers = document.querySelectorAll('.video-container');

        videoContainers.forEach(container => {
            const iframe = container.querySelector('iframe[data-src]');
            const overlay = container.querySelector('.cookie-consent-overlay');
            console.log('overlay', overlay);

            // Check if marketing cookies are accepted
            if (window.CookieConsent && window.CookieConsent.consent.marketing) {
                // Hide overlay
                if (overlay) overlay.style.display = 'none';

                // Set iframe src
                if (iframe) {
                    const dataSrc = iframe.getAttribute('data-src');
                    iframe.setAttribute('src', dataSrc);
                }
            } else {
                // Show overlay
                if (overlay) overlay.style.display = 'flex';

                // Remove iframe src
                if (iframe) iframe.removeAttribute('src');
            }
        });

        // Add event listener to open cookie preferences
        const openPreferencesButtons = document.querySelectorAll('.open-cookie-preferences');
        openPreferencesButtons.forEach(button => {
            button.addEventListener('click', (e) => {
                e.preventDefault();
                // Check if Cookiebot is available
                if (window.Cookiebot && window.Cookiebot.show) {
                    window.Cookiebot.show();
                }
            });
        });
    }

    removeEmbeds() {
        const iframes = document.querySelectorAll('iframe[data-src]');
        iframes.forEach(iframe => {
            iframe.removeAttribute('src');
        });
    }

    initListerner() {
        const self = this;

        // Listen for the consent ready event
        window.addEventListener("CookiebotOnConsentReady", function () {
            if (window.CookieConsent.consent.marketing) {
                // self.loadGoogleAnalytics();
                self.initializeEmbeds();
            }
        });

        // Initial check on page load
        self.initializeEmbeds();
    }
}
